import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'maplibre-gl/dist/maplibre-gl.css';
import { initialiseGoogleAnalytics } from './analytics';
import { App } from './App';
import { GlobalStyle } from './styles';

const app = document.querySelector<HTMLDivElement>('#app');
if (!app) throw new Error('Could not find the application root.');

initialiseGoogleAnalytics();

createRoot(app).render(
  <StrictMode>
    <GlobalStyle />
    <App />
  </StrictMode>,
);
